﻿'use strict';

/**
* Controller for the warning that the session management controller uses to warn people of an impending session end
* @memberOf components.sessionModule
* @namespace sessionTimeOutWarningModalController
*/

sessionTimeOutWarningModalController.$inject = ['$uibModalInstance', '$interval', 'data_project_constants'];

function sessionTimeOutWarningModalController($uibModalInstance, $interval, data_project_constants) {
    /* jshint validthis:true */
    var vm = this;
    vm.title = 'sessionTimeOutWarningModalController';
    vm.timeRemaining = data_project_constants.session_event_times.session_modal_count_down;
    vm.isAbleToStayLoggedIn = true;
    vm.timeDisplay = '';

    var dateTime = new Date();
    var intervalFunctionInstance = null;
    var INTERVAL_INCREMENT = 1000;
    var MINUTE_TO_MILLISECOND = 60000;
    var SECOND_TO_MILLISECOND = 1000;

    /**
    * Method to display a minute and second value based on passed in time
    * @method countDownDisplay
    * @param {time} passedInTime the time to display
    * @returns {Void}
    * @memberOf components.sessionModule.sessionTimeOutWarningModalController
    */
    vm.countDownDisplay = function (passedInTime) {
        var minutes = 0;
        var seconds = 0;

        //calculate new time
        minutes = Math.floor(passedInTime / MINUTE_TO_MILLISECOND);
        seconds = Math.floor((passedInTime % MINUTE_TO_MILLISECOND) / SECOND_TO_MILLISECOND);

        minutes = countDownDisplayFormatHelper(minutes);
        seconds = countDownDisplayFormatHelper(seconds);

        return minutes + ":" + seconds;
    }

    /**
    * Method to wrap the modal dismiss
    * @method logOut
    * @returns {Void}
    * @memberOf components.sessionModule.sessionTimeOutWarningModalController
    */
    vm.logOut = function () {

        intervalCancelHelper();
        $uibModalInstance.dismiss('logging out');
    }

    /**
    * Method to wrap the modal close
    * @method stayLoggedIn
    * @returns {Void}
    * @memberOf components.sessionModule.sessionTimeOutWarningModalController
    */
    vm.stayLoggedIn = function () {

        intervalCancelHelper();
        $uibModalInstance.close();
    }

    /**
    * Helper method to decrement the count down time
    * @method countDownTimer
    * @returns {Void}
    * @memberOf components.sessionModule.sessionTimeOutWarningModalController
    */
    function countDownTimer() {

        //check to see if timeRemaining is 0 and if so cancle timeout and return
        if (vm.timeRemaining <= 0) {
            vm.timeDisplay = vm.countDownDisplay(vm.timeRemaining);

            //ok we are done so stop the count down and disable the stay logged in button
            vm.isAbleToStayLoggedIn = false;
            intervalCancelHelper();
        }
        else {
            // call countDownDisplay and then blat result into the div on the modal
            vm.timeDisplay = vm.countDownDisplay(vm.timeRemaining);

            //decrement the timeRemaining number by a second
            vm.timeRemaining = vm.timeRemaining - INTERVAL_INCREMENT;
        }
    }

    /**
    * Helper method to display the time intervals correctly
    * @method countDownDisplayFormatHelper
    * @returns {passedNumber}
    * @memberOf components.sessionModule.sessionTimeOutWarningModalController
    */
    function countDownDisplayFormatHelper(passedNumber) {
        passedNumber = passedNumber <= 9 ? '0' + passedNumber : passedNumber;
        passedNumber = passedNumber <= 0 ? '00' : passedNumber;

        return passedNumber
    }

    /**
    * Helper method to clean up the $interval function if there is one running
    * @method intervalCancelHelper
    * @returns {Void}
    * @memberOf components.sessionModule.sessionTimeOutWarningModalController
    */
    function intervalCancelHelper() {
        if (intervalFunctionInstance != null || intervalFunctionInstance != undefined) {
            $interval.cancel(intervalFunctionInstance);
        }
    }

    //controller actions here
    vm.timeDisplay = vm.countDownDisplay(vm.timeRemaining);
    intervalFunctionInstance = $interval(countDownTimer, INTERVAL_INCREMENT);
}

module.exports = sessionTimeOutWarningModalController;



//////////////////
// WEBPACK FOOTER
// ./source/angular/components/session/sessionTimeOutWarningModalController.js
// module id = 28
// module chunks = 0